<div class="cbk-wrap">
  <div class="cbk-toolbar">
    <mat-form-field appearance="outline" class="cbk-search">
      <mat-label>Search name, email, phone or customer</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="search" (ngModelChange)="filter()" autocomplete="off">
    </mat-form-field>
    <span class="cbk-count">{{ filtered.length }} of {{ contacts.length }}</span>
    <span class="cbk-spacer"></span>
    <button mat-flat-button color="primary" (click)="newContact()"><mat-icon>person_add</mat-icon> New contact</button>
  </div>

  <div class="cbk-table-wrap">
    <table class="cbk-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Position</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Customers</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of filtered" (click)="edit(c)">
          <td class="cbk-strong">{{ c.name || 'No name' }}</td>
          <td>{{ c.stilling || c.designation }}</td>
          <td><a *ngIf="c.email" [href]="'mailto:' + c.email" (click)="$event.stopPropagation()">{{ c.email }}</a></td>
          <td class="cbk-nowrap">{{ c.phone }}</td>
          <td>
            <a *ngFor="let k of c.cards" href="" class="cbk-card" (click)="$event.preventDefault(); openCard(k.id, $event)">{{ k.name }}</a>
            <span *ngIf="!c.cards.length" class="cbk-muted">—</span>
          </td>
          <td class="cbk-actions">
            <button mat-icon-button aria-label="Delete contact" matTooltip="Delete from contact book" (click)="remove(c, $event)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </td>
        </tr>
        <tr *ngIf="!loading && !filtered.length"><td colspan="6" class="cbk-muted cbk-empty">No contacts found.</td></tr>
      </tbody>
    </table>
  </div>
</div>
